import type { GatsbyImageProps } from 'gatsby-plugin-image'
import {
  createContext,
  type CSSProperties,
  type ImgHTMLAttributes,
} from 'react'

export const DEFAULT_MIN_SVG_WIDTH = '5.625rem'
export const DEFAULT_MAX_SVG_HEIGHT = '5.625rem'

export type AssetOptionsContextProps = Partial<
  CSSProperties & {
    minSvgWidth: string
    maxSvgHeight: string
    alt: string
  } & { loading: ImgHTMLAttributes<any>['loading'] } & Pick<
      GatsbyImageProps,
      'className'
    >
>

export const AssetOptionsContext = createContext<AssetOptionsContextProps>({
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  objectPosition: '50% 50%',
  minSvgWidth: DEFAULT_MIN_SVG_WIDTH,
  maxSvgHeight: DEFAULT_MAX_SVG_HEIGHT,
  maxHeight: '100%',
  maxWidth: 'none',
  alt: '',
})
